export default "__VITE_ASSET__BkakDxVV__"